import React, { useEffect, useState } from 'react';

import _ from 'lodash';
import { components } from '../components';
import constants from '../helpers/constants';
import dateHelper from '../helpers/dateHelper';
import Enums from '../helpers/enums';
import utils from '../helpers/utils';
import { hooks } from '../hooks';
import { Routes } from '../routes';
import apiService from '../service/ApiService';
import emptyList from '../assets/icons/emptyList.jpg';

export const OrderHistory: React.FC = () => {
  const dispatch = hooks.useDispatch();
  const navigate = hooks.useNavigate();

  const [opacity, setOpacity] = useState<number>(0);
  // const [openAccordions, setOpenAccordions] = useState<Set<string>>(new Set());
  const [offset, setOffset] = useState<number>(0);
  const [isLoading, setLoading] = useState<boolean>(true);
  const [loadingMore, setLoadingMore] = useState<boolean>(false);
  const [orders, setOrders] = useState<[]>([]);

  hooks.useScrollToTop();
  hooks.useOpacity(setOpacity);
  hooks.useThemeColor('#F6F9F9', '#F6F9F9', dispatch);

  //const { ordersLoading, orders } = hooks.useGetOrders();

  useEffect(() => {
    getOrders();
  }, [offset]);

  const getOrders = async () => {
    let limit = 1000;
    if (offset > 0) {
      setLoadingMore(true);
      limit = 5;
    }
    const { data } = await apiService.getOrdersAsync({ offset, limit });
    if (data) {
      if (offset === 0) {
        setOrders(data); // Set new data directly if offset is 0
      } else {
        //setOrders((prevData) => [...prevData, ...data]); // Append data if offset is not 0
      }
    } else {
      setOffset(-1);
    }
    if (offset === 0) {
      setLoading(false);
    } else {
      setLoadingMore(false);
    }
  };

  const renderHeader = (): JSX.Element => {
    return <components.Header title='My Orders' showGoBack={true} />;
  };

  const renderContent = (): JSX.Element => {
    if (isLoading) return <components.Loader />;

    return (
      <main className='scrollable container'>
        {!_.isEmpty(orders) ? (
          orders.map((order: any, index: number) => {
            // const idStr = order.orderId.toString();
            // const isOpen = openAccordions.has(idStr);
            return (
              <div
                key={index}
                style={{
                  background: 'var(--white-color)',
                  gap: '8px',
                  marginTop: '12px',
                  marginBottom: '12px',
                  border: 'var(--white-color)',
                  borderRadius: '12px',
                  boxShadow: '0 4px 10px rgba(0,0,0,0.1)',
                  padding: '10px',
                  cursor: 'pointer',
                  transition: 'background 0.2s ease, border 0.2s ease',
                }}
                onClick={() =>
                  navigate(Routes.OrderSummary, {
                    state: { orderId: order.orderId },
                  })
                }
              >
                <section
                  style={{
                    paddingBottom: 5,
                    borderBottom: '1px solid var(--border-color)',
                  }}
                >
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      justifyContent: 'space-between',
                    }}
                  >
                    <div>
                      <h4 className='h4'>{order.siteName}</h4>
                      <p
                        style={{ marginTop: 2, color: 'var(--main-turquoise)' }}
                        className='t14'
                      >
                        <span style={{ paddingRight: 5 }}>Order</span>
                        {`#${order.orderNo}`}
                      </p>
                    </div>
                    <div>
                      <components.Button
                        text={order.status}
                        containerStyle={{
                          height: '32px',
                          padding: '10px',
                          background: 'var(--button-color)',
                          border: 'none',
                          borderRadius: 8,
                          fontWeight: 400,
                        }}
                      ></components.Button>
                    </div>
                  </div>
                </section>
                <section
                  style={{
                    marginBottom: 10,
                    borderBottom: '1px solid var(--border-color)',
                  }}
                >
                  {order.items.map((subItem: any, index: number) => {
                    const itemName =
                      subItem.type === Enums.comboType.menuItem
                        ? subItem.name
                        : subItem.comboName;
                    return (
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'flex-start',
                          padding: '10px 0px',
                        }}
                        key={index}
                      >
                        <div
                          style={{
                            flexWrap: 'wrap',
                            flex: 1,
                          }}
                          className='t14'
                        >
                          <span>{subItem.quantity} X </span>
                          <span style={{ flexShrink: 1 }}>{itemName}</span>
                        </div>
                        <div style={{ alignSelf: 'flex-end' }}>
                          <span className='t14'>
                            {order.paymentMethodId !==
                              constants.userPointsMethodId && subItem.price > 0
                              ? utils.formatCurrency(subItem.price)
                              : '$0.00'}
                          </span>
                        </div>
                      </div>
                    );
                  })}
                </section>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                  }}
                >
                  <h5>{dateHelper.displayDatetime(order.promiseDateTime)}</h5>
                  <p className='t14'>
                    {utils.formatCurrency(order.orderAmount)}
                  </p>
                </div>
              </div>
            );
          })
        ) : (
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              minHeight: '65vh',
            }}
          >
            <img
              src={emptyList}
              alt='no data'
              style={{ width: '50%', height: '50%' }}
            />
            <p className='t16'>No Record Found</p>
          </div>
        )}
      </main>
    );
  };

  return (
    <div id='screen' style={{ opacity }}>
      {renderHeader()}
      {renderContent()}
    </div>
  );
};
